/** Onda decorativa entre secciones (ancho 100% del contenedor, sin desbordar en móvil). */
export default function SectionTopWave({ className = 'text-white' }) {
  return (
    <div
      className="pointer-events-none absolute inset-x-0 top-0 z-[1] h-14 -translate-y-full overflow-hidden md:h-[4.25rem]"
      aria-hidden
    >
      <svg
        className={`block h-full w-full max-w-none ${className}`}
        viewBox="0 0 1440 56"
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="currentColor"
          d="M0,56 V22 C200,6 400,48 600,26 S1000,4 1200,24 S1380,44 1440,20 V56 H0 Z"
        />
      </svg>
    </div>
  );
}
